import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import InputBox from "../../components/InputBox";
import Button from "../../components/Button";
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import Login from "./Login";
import "./Login.scss";
import { POST_AUTH,POST_AUTH_SYNC } from "../../utils/HTTP.utils";
//import {getIsUaAuthentication} from "../../hooks/useAuthentication"
import { API_PROFILE } from "../../middleware/constants/url.constants";
import { connect } from "react-redux";
import useAuthentication from "../../hooks/useLoginAuthentication";
import { useSelector } from "react-redux";
import { UPDATE_AUTH_DATA } from "../../middleware/constants/auth.constants";
import {isValidPhoneNumber} from "react-phone-number-input";
import Input from "react-phone-number-input/input";

function CreateAccount({ modalHandler ,  userData, modalclose, updateLoginStatus }) {
  const logAuth = useAuthentication();

  const userInfo = useSelector((state) => state.auth.userData);
  const socialuser = useSelector((state) => state.auth.user);

  const [loader, setLoader] = useState(false);
  const [color, setColor] = useState("continue");
  const [invalidEmailError, setInvalidEmailError] = useState(false);
 // const [invalidPhoneError, setInvalidPhoneError] = useState(false);

  const [fields, setFields] = useState({
    firstName: userData?.firstname || "",
    lastName:  userData?.lastname || "",
    phoneNumber:  userData?.phone || "",
    email:  userData?.email || ""
    //telCode : "+1",
  });

  const [errorFields, setErrorFields] = useState({
    firstName: false,
    lastName: false,
    phoneNumber: false,
    email: false,
    invalidEmail: false,
    invalidphoneNo: false,
    //telCode : false,
  });

  const handleChange = (e) => {
    setFields((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePhone = e => {
    // setFields((prev) => ({
    //   ...prev,
    //   phoneNumber: e
    // }));
    setFields({ ...fields, phoneNumber: e });
  }

  useEffect(() => {
  isFormValidOnSubmit()
}, []);


  useEffect(() => {
    if (
      fields.firstName !== "" &&
      fields.lastName !== "" &&
      fields.email !== "" &&
      fields.password !== "" &&
      fields.phoneNumber !== ""       
    ) {
      setColor("yellow");
    } else {

      setColor("continue");
    }
  }, [fields,invalidEmailError]);

  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValidOnSubmit()) {
      const socialLogin = localStorage.getItem("socialLogin")
   
      if(socialLogin === "yes") {        
        localStorage.removeItem("socialLogin")
        const firstname = fields?.firstName;
        const lastname = fields?.lastName;
        const email = socialuser?.attributes?.email ;
        const phone = fields?.phoneNumber;
        //const phone = "+1"+ph;

        const displayEmail = fields?.email;
      
        if (firstname && firstname !== "null" && firstname !== "") {
        
          logAuth.getIsUaAuthentication(userInfo)
            .then(({ token, user }) => {
              const res =  POST_AUTH_SYNC(
                API_PROFILE,
                {
                  firstname,
                  lastname,
                  email,
                  phone,
                  displayEmail
                },
                token
              ).then((res) => {
                console.log(res)
       
                if(res.status === 200) {
                  toast.success("Changes Saved Successfully")
                  userData = {
                    firstname : firstname,
                    lastname : lastname,
                    email : email,
                    displayemail : email,
                    phone : phone
                  }
                  updateLoginStatus(true,userData, false,user);
                  modalclose();
                  window.location.reload();
                }
              });
              
            })
            .then(() => {
              // toast.success("Changes Saved Successfully")
              // userData = {
              //   firstname : firstname,
              //   lastname : lastname,
              //   email : email,
              //   phone : phone
              // }
              // updateLoginStatus(true,userData, false);
              // modalclose();

            });
        }
      }
      else{
        modalHandler("createPassword", fields);

      }
    }
  };

  const isFormValidOnSubmit = () => {
    let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
   // let phoneRegex = /^\d/;
    const errors = {
      firstName: false,
      lastName: false,
      phoneNumber: false,
      email: false,
      invalidEmail: false,
      invalidphoneNo: false,
    };

    if (fields.firstName === "" || /\s/.test(fields.firstName)) {  
      errors.firstName = true;
    }

    if (fields.lastName === "" || /\s/.test(fields.lastName)) {  
      errors.lastName = true;
    }

    if (fields.phoneNumber === undefined || fields.phoneNumber === "") {
      errors.phoneNumber = true;
    }
    else {
      errors.phoneNumber = false;
      if(isValidPhoneNumber(fields.phoneNumber)=== false) {
        errors.invalidphoneNo = true;
      }
    }

    if (fields.email === "") {
      errors.email = true;
      setInvalidEmailError(false)
    } else {
      if (!emailRegex.test(fields.email)) {

        errors.invalid=true;
        setInvalidEmailError(true)
      }else{
        errors.invalid=false;
        setInvalidEmailError(false)
      }
    }
    console.log(errors);
    setErrorFields(errors);
    if ((Object.values(errors).some((error) => error === true))) {

      console.log(invalidEmailError);


      return false;
    }
    return true;
  };


  const isFieldValid = (e) => {
    let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    const { name, value } = e.target;
  
    let errors = false;
  
    if (name === 'firstName' && (value === "" || /\s/.test(fields.firstName))) {
      errors = true;
    }
  
    if (name === 'lastName' && (value === "" || /\s/.test(fields.lastName))) {
      errors = true;
    }
  
    if (name === 'phoneNumber' && value === "") {
      errors = true;
    }
  
    if (name === 'email' && value === "") {
      errors = true;
      setInvalidEmailError(false)
    } 

    //  else if (name === 'email' && !emailRegex.test(value)) {
    //  // errors=true;
    //  setErrorFields((prev) => ({
    //   ...prev,
    //   invalidEmail: true,
    // }));
    // }
  
    setErrorFields((prev) => ({
      ...prev,
      [name]: errors,
      //invalidEmail: false,
    }));
  };



  useEffect(() => {  
    if (userData?.hasOwnProperty("firstname")) {
      setFields((prev) => ({
        ...prev,
        "firstName": userData.firstname,
      }));
    }
    else if (userData?.hasOwnProperty("lastname")) {
      setFields((prev) => ({
        ...prev,
        "lastName": userData.lastname,
      }));
    }
    else if (userData?.hasOwnProperty("phone")) {
      setFields((prev) => ({
        ...prev,
        "phoneNumber": userData.phone,
      }));
    }
    else if (userData?.hasOwnProperty("email")) {
     
      setFields((prev) => ({
        ...prev,
        "email": userData.email,
      }));
    }


  }, [userData]);

  return (
    <div className="login-root">
      <div className="login-wrapper">
      <LoadingOverlay active={loader} spinner text="Loading...">
        <h1 className="title">Create <br/> Account</h1>
        <form className="login-form">
          <InputBox
            type='text'
            placeholder="First Name"
            className={`input-grp ${errorFields.firstName && "error"}`}
            name="firstName"
            onChange={handleChange}
            onBlur={isFieldValid}
            value={fields.firstName}

          />
          {errorFields.firstName && <p className="danger">Field required</p>}

          <InputBox
            type='text'
            placeholder="Last Name"
            className={`input-grp ${errorFields.lastName && "error"}`}
            name="lastName"
           // value={userData?.firstname ?? ""}
            onChange={handleChange}
            onBlur={isFieldValid}
            //onFocus={handleFocus}
            value={fields.lastName}

          />
          {errorFields.lastName && <p className="danger">Field required</p>}

          <Input
              required
              defaultCountry="US"
              className={`phone-input input-grp ${(errorFields.phoneNumber || errorFields.invalidphoneNo) && "error"}`}
              name="phoneNumber"
              placeholder="Phone Number"
              value={userData?.phone ?? ""}
              onChange={handlePhone}
              onBlur={isFieldValid}
            />
          {!errorFields.invalidphoneNo && errorFields.phoneNumber && <p className="danger">Field required</p>}
          {!errorFields.phoneNumber && errorFields.invalidphoneNo && (
            <p className="danger">Invalid Phone Number</p>
          )}

          <InputBox
            type="email"
            placeholder="Email"
            className={`input-grp ${(errorFields.email || errorFields.invalidEmail) && "error"}`}
            name="email"
            onChange={handleChange}
           // onFocus={handleFocus}
           onBlur={isFieldValid}
           value={fields.email}
          />
          {errorFields.email && <p className="danger">Field required</p>}
          {invalidEmailError && <p className="danger">Invalid email</p>}

          <div style={{ marginTop: '30px' }}>
            <Button
              btnAction={"submit"}
              label={"Continue"}
              type={color}
              size={"large"}
              onClick={(e) => handleSubmit(e)}
            />
          </div>
        </form>
      </LoadingOverlay>

      
      </div>
      <div className="message-ca">
        “You will receive $3,000 in Flight Credits for setting up a Free Account with AIRBOOK ONE”.
      </div>
    </div>
  );
}


function mapStateToProps({ auth }) {
  return {
    loginStatus : auth.loginStatus,
    loginUserData : auth.userData,
    user : auth.user
  };
}
function mapDispatchToProps(dispatch) {
  return {
    updateLoginStatus : (status, userData, createAccount, socialuser ) => dispatch({ type: UPDATE_AUTH_DATA, loginStatus : status , userData : userData, createAccount : createAccount, user : socialuser})
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount);
